import { Component } from '@angular/core';

@Component({
  selector: 'app-image-placeholder-icon',
  imports: [],
  templateUrl: './image-placeholder-icon.html',
  styleUrl: './image-placeholder-icon.scss'
})
export class ImagePlaceholderIcon {

}
